import axios from 'axios'
import toast from 'react-hot-toast'
import store from '../store'
import { loginFailure, refreshTokenAction } from '../store/modules/auth/actions'
import retry from 'retry'
import { initialMenu } from '../store/modules/menu/actions'
import { cercDeleteAllURs } from '../store/modules/cerc/actions'

const api = axios.create({
    baseURL: 'https://treeweb.com.br:4003', //Producao
    // baseURL: 'http://localhost:4005',
    // baseURL: 'https://treeweb.com.br:4005', //Homologacao
})

api.interceptors.request.use(
    (config) => {
        // const token = TokenService.getLocalAccessToken();
        // if (token) {
        //     // config.headers["Authorization"] = 'Bearer ' + token;  // for Spring Boot back-end
        //     config.headers["x-access-token"] = token; // for Node.js Express back-end
        // }
        // muito provavelmente já temos o token
        // const state = store.getState()
        // const token = state.auth.token
        // api.defaults.headers.common['Authorization'] = `Bearer ${token}`
        //
        return config
    },
    (error) => {
        return Promise.reject(error)
    }
)

api.interceptors.response.use(
    (res) => {
        return res
    },
    async (err) => {
        const originalConfig = err.config

        if (originalConfig.url !== '/login' && err.response) {
            // Access Token was expired
            if (err.response.status === 401 && !originalConfig._retry) {
                originalConfig._retry = true

                try {
                    // fezendo a requisição para o backend com o refresh token
                    // e dps alterando o access token do front
                    const state = store.getState()
                    const refreshTokenId = state.auth.refreshToken

                    const { data } = await api.post('/auth/refreshtoken', {
                        refreshTokenId: refreshTokenId,
                    })

                    const { token, refreshToken } = data
                    api.defaults.headers.common[
                        'Authorization'
                    ] = `Bearer ${token}`
                    store.dispatch(refreshTokenAction({ refreshToken, token }))

                    return api(originalConfig)
                } catch (_error) {
                    toast.error(
                        'Você foi desconectado, por favor, entre novamente!'
                    )

                    store.dispatch(loginFailure())
                    store.dispatch(initialMenu())
                    store.dispatch(cercDeleteAllURs())

                    return Promise.reject(_error)
                }
            }
        }
        return Promise.reject(err)
    }
)

export const operation = retry.operation({
    retries: 2,
    factor: 3,
})

export default api
